import { transparentize } from "polished"

const primary = {
	white: '#FFF',
	black: '#000',
	dark: "rgb(17, 17, 17)",
	gray: "#E9E9E9",
	darkGray: "#4D4D4D",
}

const secondary = {
	darkGreen: "#143630",
	goldenYellow: "#F5CB5C",
	lightBeige: "#E9CEB3",
}

const topics = {
	lightBlue: "#B4C5E4",
	amethystPurple: "#5F45B6",
	orange: "#F39B41",
	orangeBg: "#FDEBD9",
	orangeText: "#794E20",
	burgundy: "#5C2751",
	darkTeal: "#08605F",

	// New Colors.
	blue: "#7697E6",
	blueBg: "#E1E8F4",
	blueText: "#484F5B",
	coralRed: "#E26465",
	coralRedBg: "#F8DADA",
	coralRedText: "#A44445",
	indigoBlue: "#333865",
	indigoBlueBg: "#D4D6E7",
	indigoBlueText: "#1F223D",
	teal: "#4C8A8A",
	tealBg: "#D1E5E5",
	tealText: "#336060",
}

const tags = {
	lifeBg: "#E5F2F2",
	lifeText: "#336060",
	sciencesBg: "#E7E9F2",
	sciencesText: "#1F223D",
	thoughtsBg: "#FDE7D5",
	thoughtsText: "#B46F2C",
	artsBg: "#FBE1E1",
	artsText: "#A44445",
	literatureBg: "#E6F2FB",
	literatureText: "#155D81",
	defaultBg: "rgba(17, 17, 17, 0.1)",
	defaultText: "rgba(17, 17, 17, 1)",
}

const support = {
	grayBlue: "#484F5B",
	errorRed: {
		normal: "#aa1616",
		light: "#f8d7da",
		dark: "#58151c",
	},
	successGreen: {
		normal: "#22543D",
		light: "#d1e7dd",
		dark: "#0a3622",
	},
}

const tints = {
	black: {
		70: transparentize(0.3, primary.black),
		60: transparentize(0.4, primary.black),
		50: transparentize(0.5, primary.black),
		30: transparentize(0.7, primary.black),
		10: transparentize(0.9, primary.black),
		5: transparentize(0.95, primary.black),
	},
	white: {
		70: transparentize(0.3, primary.white),
		60: transparentize(0.4, primary.white),
		50: transparentize(0.5, primary.white),
		40: transparentize(0.6, primary.white),
		30: transparentize(0.7, primary.white),
		20: transparentize(0.8, primary.white),
		10: transparentize(0.9, primary.white),
		5: transparentize(0.95, primary.white),
	},
	dark: {
		80: transparentize(0.2, primary.dark),
		70: transparentize(0.3, primary.dark),
		60: transparentize(0.4, primary.dark),
		50: transparentize(0.5, primary.dark),
		40: transparentize(0.6, primary.dark),
		30: transparentize(0.7, primary.dark),
		20: transparentize(0.8, primary.dark),
		10: transparentize(0.9, primary.dark),
		5: transparentize(0.95, primary.dark),
	}
}

const overlays = {
	generic: `
		linear-gradient(
			180deg,
			rgba(17, 17, 17, 0.8) 0%,
			rgba(17, 17, 17, 0.3) 10%,
			rgba(17, 17, 17, 0.3) 25%,
			rgba(17, 17, 17, 0.5) 35%,
			rgba(17, 17, 17, 0.7) 50%,
			rgba(17, 17, 17, 0.8) 100%
		)
	`,
	sliderAuthorCard: `
		linear-gradient(
			180deg,  
			rgba(17, 17, 17, 0) 0%,
			rgba(17, 17, 17, 0.3) 40%,
			rgba(17, 17, 17, 0.9) 80%
		)
	`,
	podcastCard: `
		linear-gradient(
			180deg,  
			rgba(17, 17, 17, 0.2) -20%,
			rgba(17, 17, 17, 0.9) 80%
		)
	`,
}

export const colors = {
	primary,
	secondary,
	topics,
	support,
	tints,
	tags,
	overlays,
}